import { OdataManager } from '@/api/odata/odata-manager';
import { MeasurementUnit } from '@/api/model/interfaces';

export default class MeasurementUnitOdata extends OdataManager<MeasurementUnit> {}
